/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadgeAlt9S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.143 9.7c-.193-.233-.29-.543-.29-.93 0-.413.104-.74.31-.98.214-.24.5-.36.86-.36.367 0 .654.117.86.35.207.233.31.557.31.97 0 .18-.013.357-.04.53-.273.507-.683.76-1.23.76-.326 0-.586-.113-.78-.34z" />
        <path d="M11.305.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 10l1.145 2.342a1 1 0 0 1-.43 1.323l-2.303 1.221-.45 2.568a1 1 0 0 1-1.125.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 17.906l-2.581.365a1 1 0 0 1-1.125-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 10 2.542 7.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 1.73l2.581.365zm.668 11.429-1.29 1.79h1.66l1.17-1.63a6.67 6.67 0 0 0 .86-1.56c.2-.533.3-1.023.3-1.47 0-.833-.233-1.48-.7-1.94-.466-.467-1.116-.7-1.95-.7-.533 0-1 .107-1.4.32s-.71.517-.93.91c-.213.387-.32.843-.32 1.37 0 .733.197 1.313.59 1.74.394.427.93.64 1.61.64.334 0 .637-.077.91-.23-.14.233-.31.487-.51.76z" />
        <path d="m10.61 20.438-1.523-1.473L8 19.119v4.88l4-1.5 4 1.5v-4.88l-1.087-.154-1.522 1.473a2 2 0 0 1-2.782 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgBadgeAlt9S as BadgeAlt9S };
